import { createContext } from 'react';
export const SortContext = createContext(undefined);
